import axios from "../utils/axios.wrapper";

export const getAllSubscriptions = async () => {
  const { data } = await axios.get("/BeneficiarySubscription");
  return data.items || data;
};

export const getSubscriptionsByCustomer = async (customerId) => {
  const { data } = await axios.get(
    `/BeneficiarySubscription/customer/${customerId}`,
  );
  return data.items || data;
};

export const createSubscription = async (subscription) => {
  const { data } = await axios.post(
    "/BeneficiarySubscription/create",
    subscription,
  );
  return data;
};

export const updateSubscription = async (id, subscription) => {
  const { data } = await axios.put(
    `/BeneficiarySubscription/${id}`,
    subscription,
  );
  return data;
};

export const deleteSubscription = async (id) => {
  const { data } = await axios.delete(`/BeneficiarySubscription/${id}`);
  return data;
};
export const getCustomerSubscriptions = async (customerId) => {
  const { data } = await axios.get(`/beneficiarysubscription/customer/${customerId}`);
  return data.items || data;
};

export const getByCodeBar = async (code) => {
  const { data } = await axios.get(
    `/beneficiarysubscription/codebar/${encodeURIComponent(code)}`
  );
  return data;
};

export const rechargeSubscription = async (id, rechargeData) => {
  const { data } = await axios.post(`/BeneficiarySubscription/${id}/recharge`, rechargeData);
  return data;
};

export const beneficiarySubscriptionService = {
  getAllSubscriptions,
  getSubscriptionsByCustomer,
  createSubscription,
  updateSubscription,
  deleteSubscription,
  getCustomerSubscriptions,
  getByCodeBar,
  rechargeSubscription,
};
